const Features = () => {
  const featureData = [
    {
      title: "Single Interface",
      description: "A one-stop solution platform",
    },
    {
      title: "Lifestyle Essential Maps",
      description: "Displays curated lifestyle preferences",
    },
    {
      title: "Neighborhood Character Maps",
      description: "Highlights the experience of walking around the neighborhood",
    },
    {
      title: "Radial Pattern",
      description: "Maps the 5-10-20 minute neighborhood radius from any listing",
    },
    {
      title: "Quick Multiple Searches",
      description: "Instant multiple searches like a Trader Joe's, urgent care and Italian restaurant within walking distance",
    },
    {
      title: "Relevant Filters",
      description: "Detailed filters on things that matter such as schools, transit, and leisure",
    },
    {
      title: "Comparing Neighborhoods",
      description: "Comparative view of character and quality of neighborhoods",
    },
    {
      title: "Neighborhood Reports",
      description: "Seamless complement to property reports",
    },
    {
      title: "Client Preference Analytics",
      description: "Records what clients love in a neighborhood",
    },
    {
      title: "Recommendation System",
      description: "Offers the best neighborhood based on relevancy search",
    },
    {
      title: "Millions of Data Points",
      description: "Proprietary and open data content to satisfy AI-savvy buyers",
    },
    {
      title: "Proximity data",
      description: "Measure of steps, calories burned, and distance to each location",
    },
    {
      title: "Climate Friendliness",
      description: "Carbon emissions saved by walking",
    },
    {
      title: "Bespoke Customization",
      description: "Feature preferences and unique design",
    },
    {
      title: "Seamless Integration",
      description: "Simple Sign-in",
    },
  ];

  return (
    <div className="w-full bg-[#1c293a] py-20 px-4 md:px-12 lg:px-24 text-white">
      <div className="text-3xl text-center pb-12">
        Walkspan offers meaningful content, functions, and capabilities
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
        {featureData.map((feature, idx) => (
          <div key={idx} className="flex min-h-[65px] max-w-[390px] px-4 md:px-0">
            <div className="font-medium mr-4">{idx + 1}</div>
            <div>
              <div className="font-bold">{feature.title}</div>
              <div>{feature.description}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Features;
